export default __webpack_public_path__ + "static/media/pdf.6f6a7833.svg";